


















































import { Component, Vue } from "vue-property-decorator";
import { FormEvents } from "../constants";
import { SongModel } from "../models/Song";
import { GlobalEvent } from "../shared/helpers";
import { mixins } from "vue-class-component";
import { DataTableMixin } from "../shared/mixins/datatable.mixin";
import { songsService } from "../api/songs.api";
import SongFrom from "../modals/SongForm.vue";

@Component({
  components: {
    SongFrom
  }
})
export default class Songs extends mixins(DataTableMixin) {
  songs: SongModel[] = [];

  pagination = {
    page: 1,
    pageCount: 0,
    perPage: 10,
    total: 0,
    skipped: 0
  };

  headers = [
    {
      name: "Title",
      prop: "title"
    },
    {
      name: "Link",
      prop: "link"
    }
  ];

  mounted() {
    this.handleSongs();
  }

  fetchData() {
    this.handleSongs();
  }

  async handleSongs() {
    try {
      this.showLoading();
      const response = await songsService.getAll({
        page: this.pagination.page,
        limit: this.pagination.perPage
      });
      this.songs = response.data;
      this.pagination = response.pagination;
      this.hideLoading();
    } catch (error) {
      this.handleError(error);
    }
  }

  async myCallback(page: number) {
    this.pagination.page = page;
    this.handleSongs();
  }

  async handleLimitChange(limit: number) {
    this.pagination.perPage = limit;
    this.handleSongs();
  }

  async showModal(item: SongModel) {
    GlobalEvent.$emit(FormEvents.SH_SONG_FORM, item);
  }
}
